import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const transactionsDriverObj = (dispatch) => {
  const steps = [
    {
      element: '.exportTransactions',
      popover: {
        title: 'Export Transactions',
        description: 'Export transaction history to CSV format for record keeping and analysis.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.transactionFiltersToggleButton',
      popover: {
        title: 'Filters Toggle Button',
        description: 'Click here to toggle the filter menu to filter transactions.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.transactionFilters',
      popover: {
        title: 'Filter Transactions',
        description: 'Filter transactions by date, type, item, or other criteria to find specific records.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.transactionTable',
      popover: {
        title: 'Transaction History',
        description: 'View all inventory transactions with details like date, type, quantity, and involved items.',
        side: 'left',
        align: 'start',
      },
    },
  ].filter((step) => document.querySelector(step.element) !== null);

  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps,
  });
  return driverObj;
};

export default transactionsDriverObj;
